import { render, staticRenderFns } from "./v-selector.vue?vue&type=template&id=7f42aeba&scoped=true"
import script from "./v-selector.vue?vue&type=script&lang=js"
export * from "./v-selector.vue?vue&type=script&lang=js"
import style0 from "../../../css/selector-base.less?vue&type=style&index=0&id=7f42aeba&prod&scoped=true&lang=less&external"
import style1 from "./v-selector.vue?vue&type=style&index=1&id=7f42aeba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f42aeba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
